// src/components/agent/parts/toolLabels.js
//
// Human-readable labels for background-capable tools, used by the
// "Background job submitted/completed" chips. Unknown tools fall back to a
// prettified spelling of their snake_case name.
const TOOL_LABELS = {
  get_bigquery_data: 'Get Data',
  execute_bash: 'Run Command',
  run_company_data_function: 'Run Function',
  dispatch_subagent: 'Dispatch Subagent',
};

export const toolLabel = (name) => {
  if (TOOL_LABELS[name]) return TOOL_LABELS[name];
  return String(name || 'tool')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export default toolLabel;
